// Fix: an external script from SC Product Options / Bold Product Options
// (loaded via snippets/sc-includes.liquid -> https://options.shopapps.site/js/options.js)
// inserts a plain-formatted price span + a redundant <sup> immediately after
// each ".Bold-theme-hook-DO-NOT-DELETE" marker, duplicating the cents that
// snippets/price-as-money.liquid already rendered correctly elsewhere on the
// same line (e.g. "$34.95" followed by a stray "95" in superscript).
//
// This script only removes that redundant trailing <sup> element. It never
// touches the Bold-theme-hook span itself, never touches sc-includes.liquid,
// and never touches price-as-money.liquid. If Shop Circle's script changes
// its injection pattern in the future, this stops matching and simply does
// nothing (fails safe, not silently wrong).
(function () {
  function stripDuplicateSup(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.Bold-theme-hook-DO-NOT-DELETE').forEach(function (hook) {
      var span = hook.nextElementSibling;

      // Only act if the very next sibling is a plain <span> already
      // containing a full decimal price (e.g. "$34.95").
      if (span && span.tagName === 'SPAN' && /\d\.\d{2}/.test(span.textContent)) {
        var sup = span.nextElementSibling;

        // Only remove it if it's the specific redundant <sup> pattern
        // (a bare 2-digit cents value), not any other superscript on the page.
        if (sup && sup.tagName === 'SUP' && /^\d{2}$/.test(sup.textContent.trim())) {
          sup.remove();
        }
      }
    });
  }

  // Clean up whatever is already on the page (e.g. server-rendered cart page).
  stripDuplicateSup(document);

  // Watch for AJAX cart re-renders (add-to-cart, quantity change, cart drawer
  // refresh) and clean up the duplication every time new markup is inserted.
  //
  // Important: we rescan mutation.target (the parent whose children changed),
  // not just the individual added node. SC's script frequently appends the
  // redundant <sup> as a lone new sibling *after* the hook + price span
  // already exist (rather than replacing the whole hook+span+sup block at
  // once). querySelectorAll never matches the root it's called on, only its
  // descendants — so calling it on that lone new <sup> node finds nothing,
  // since the hook lives outside it as an earlier sibling, not a descendant.
  // Rescanning the shared parent (target) instead covers both the hook/span
  // and the newly appended sup regardless of which one triggered the mutation.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'childList' && m.target) {
        stripDuplicateSup(m.target);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();